import React from "react";
import { useLang } from "../context/LanguageContext";
import { PageHead } from "./Shop";
import ApplyVideos from "../components/ApplyVideos";
import useSeo from "../hooks/useSeo";

const ApplicationGuide = () => {
  const { ui } = useLang();
  useSeo({
    title: { en: "How It's Applied to Your Spaces", tr: "Mekânlarınıza Nasıl Uygulanır" },
    description: {
      en: "Step-by-step HAAS Mosaic application guides in English and Turkish — unboxing, surface prep, adhesive, grouting and finishing.",
      tr: "HAAS Mosaic uygulama rehberi — paket açma, zemin hazırlığı, yapıştırma, derzleme ve vernik adımları (Türkçe ve İngilizce).",
    },
  });

  return (
    <div>
      <PageHead
        title={ui.applyTitle}
        subtitle={ui.applyIntro}
        image="/mosaic/2026/gallery-hero.jpg"
        imagePosition="center"
      />
      <section className="py-20 md:py-28 bg-[#f7f3ee]">
        <div className="max-w-[1360px] mx-auto px-5 md:px-8">
          <ApplyVideos />
        </div>
      </section>
    </div>
  );
};

export default ApplicationGuide;
